import { b as _createClass, c as _classCallCheck, e as _defineProperty, f as _objectSpread2, i as _toConsumableArray } from './_rollupPluginBabelHelpers-047e4aae.js';

// TODO: make sure app import will have a single instance of phrase
// TODO: add usage doc
// TODO: Usage warning, not to use for creating keys
// TODO: ADD doc string
// TODO: Add export
/**
 * @class
 * A string management module for your application
 * * It stores different variation of each string like
 * * Uppercase, Lowercase, Capitalized, Hyphenated
 * * @param {string} locale set language locale, default is 'en'
 */
var Phrases = /*#__PURE__*/_createClass(function Phrases() {
  var _this = this;
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  _classCallCheck(this, Phrases);
  /**
   * @method
   * Set locale for phrases
   * Adds preceding key to the specified locale language
   * @param {string} value language locale
   * @returns {*} object reference
   */
  _defineProperty(this, "setLocale", function (value) {
    _this.locale = value;
    return _this;
  });
  /**
   * @method
   * Validates the value to be set
   * Returns true, if value provided is non-empty and string
   * @param {string} value
   * @returns {boolean}
   */
  _defineProperty(this, "isValid", function (value) {
    return typeof value === "string" && Boolean(value.trim());
  });
  /**
   * @method
   * Converts the value to uppercase
   * Returns the string which is converted
   * @param {string} value
   * @returns {string}
   */
  _defineProperty(this, "_toUpperCase", function (value) {
    return value.trim().toUpperCase();
  });
  /**
   * @method
   * Converts the value to lowercase
   * Returns the string which is converted
   * @param {string} value
   * @returns {string}
   */
  _defineProperty(this, "_toLowerCase", function (value) {
    return value.trim().toLowerCase();
  });
  /**
   * @method
   * Converts the value to capitalize format
   * Returns the string which is converted
   * @param {string} value
   * @returns {string}
   */
  _defineProperty(this, "_toCapitalize", function (value) {
    return value.trim().toLowerCase().replace(/\w\S*/g, function (w) {
      return w.replace(/^\w/, function (c) {
        return c.toUpperCase();
      });
    });
  });
  /**
   * @method
   * Converts the value to hyphenated format
   * Returns the string which is converted
   * @param {string} value
   * @returns {string}
   */
  _defineProperty(this, "_toHyphenated", function (value) {
    return value.trim().toLowerCase().split(" ").join("-");
  });
  /**
   * @method
   * Set default key
   * @param {string} key
   * @param {string} value
   * @returns {*} object reference
   */
  _defineProperty(this, "setDefault", function (key, value) {
    if (_this.isValid(value)) _this.phrases[_this.locale][key].DEFAULT = value.trim();
    return _this;
  });
  /**
   * @method
   * Set Uppercase key
   * @param {string} key
   * @param {string} value
   * @returns {*} object reference
   */
  _defineProperty(this, "setUpperCase", function (key, value) {
    if (_this.isValid(value)) _this.phrases[_this.locale][key].UPPERCASE = _this._toUpperCase(value);
    return _this;
  });
  /**
   * @method
   * Set Lowercase key
   * @param {string} key
   * @param {string} value
   * @returns {*} object reference
   */
  _defineProperty(this, "setLowerCase", function (key, value) {
    if (_this.isValid(value)) _this.phrases[_this.locale][key].LOWERCASE = _this._toLowerCase(value);
    return _this;
  });
  /**
   * @method
   * Set hyphenated key
   * @param {string} key
   * @param {string} value
   * @returns {*} object reference
   */
  _defineProperty(this, "setHyphenated", function (key, value) {
    if (_this.isValid(value)) _this.phrases[_this.locale][key].HYPHENATED = _this._toHyphenated(value);
    return _this;
  });
  /**
   * @method
   * Set capitalize key
   * @param {string} key
   * @param {string} value
   * @returns {*} object reference
   */
  _defineProperty(this, "setCapitalize", function (key, value) {
    if (_this.isValid(value)) _this.phrases[_this.locale][key].CAPITALIZE = _this._toCapitalize(value);
    return _this;
  });
  /**
   * @method
   * Set plural key
   * @param {string} key
   * @param {string} value
   * @param {object} suffix
   * @returns {*} object reference
   */
  _defineProperty(this, "setPlural", function (key, value, suffix) {
    _this.phrases[_this.locale][key].PLURAL = {};
    if (suffix && _this.isValid(suffix.plural)) {
      var pluralSuffix = suffix.plural;
      var finalValue = value.trim() + pluralSuffix;
      _this.phrases[_this.locale][key].PLURAL.DEFAULT = finalValue;
      _this.phrases[_this.locale][key].PLURAL.UPPERCASE = _this._toUpperCase(finalValue);
      _this.phrases[_this.locale][key].PLURAL.LOWERCASE = _this._toLowerCase(finalValue);
      _this.phrases[_this.locale][key].PLURAL.CAPITALIZE = _this._toCapitalize(finalValue);
      _this.phrases[_this.locale][key].PLURAL.HYPHENATED = _this._toHyphenated(finalValue);
    }
    return _this;
  });
  /**
   * @method
   * Set verb key
   * @param {string} key
   * @param {string} value
   * @param {object} suffix
   * @returns {*} object reference
   */
  _defineProperty(this, "setVerb", function (key, value, suffix) {
    _this.phrases[_this.locale][key].VERB = {};
    if (suffix && _this.isValid(suffix.verb)) {
      var formattedSuffix = suffix.verb.trim().toLowerCase();
      var trimmedValue = value.trim();
      _this.phrases[_this.locale][key].VERB.DEFAULT = trimmedValue + formattedSuffix;
      _this.phrases[_this.locale][key].VERB.UPPERCASE = trimmedValue.toUpperCase() + formattedSuffix.toUpperCase();
      _this.phrases[_this.locale][key].VERB.LOWERCASE = trimmedValue.toLowerCase() + formattedSuffix;
      _this.phrases[_this.locale][key].VERB.CAPITALIZE = trimmedValue.toLowerCase().replace(/\w\S*/g, function (w) {
        return w.replace(/^\w/, function (c) {
          return c.toUpperCase();
        });
      }) + formattedSuffix;
      _this.phrases[_this.locale][key].VERB.HYPHENATED = trimmedValue.toLowerCase().split(" ").join("-") + formattedSuffix;
    }
    return _this;
  });
  /**
   * @method
   * create key from value
   * @param {string} value
   * @returns {string} key
   */
  _defineProperty(this, "createKey", function (value) {
    if (_this.isValid(value)) return value.toUpperCase().split(" ").join("_");
  });
  /**
   * @method
   * Set phrase keys
   * @param {string} key
   * @param {string} value
   * @returns {*} object reference
   */
  _defineProperty(this, "setPhrase", function () {
    var value = (arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 0 ? undefined : arguments[0]);
    var key = (arguments.length <= 1 ? undefined : arguments[1]) ? arguments.length <= 0 ? undefined : arguments[0] : _this.createKey(value);
    var suffix = (arguments.length <= 2 ? undefined : arguments[2]) ? arguments.length <= 2 ? undefined : arguments[2] : {}; // For Plural and Verb

    if (!_this.phrases[_this.locale]) {
      _this.phrases = _objectSpread2(_objectSpread2({}, _this.phrases), {}, _defineProperty({}, _this.locale, {}));
    }
    if (_this.phrases[_this.locale][key]) {
      throw new ReferenceError("Invalid assignment: Duplicate Key.");
    }
    _this.phrases[_this.locale][key] = {};
    _this.setDefault(key, value).setUpperCase(key, value).setLowerCase(key, value).setHyphenated(key, value).setCapitalize(key, value).setPlural(key, value, suffix).setVerb(key, value, suffix);
    return _this;
  });
  /**
   * @method
   * Get phrase value
   * @param {string} key
   * @returns {string} value of phrase
   */
  _defineProperty(this, "getPhrase", function (key) {
    var keyArr = key.split(".");
    keyArr = keyArr.length > 1 ? [_this.locale].concat(_toConsumableArray(keyArr)) : [_this.locale].concat(_toConsumableArray(keyArr), ["DEFAULT"]);

    // If the query is for plural or verb format string
    // And user has not mentioned the string format,
    // then user will get the default value of plural or verb
    if (keyArr[keyArr.length - 1] === "PLURAL" || keyArr[keyArr.length - 1] === "VERB") {
      // If the keyArr has 3 items - locale, key of the string,
      // and the queried format then we need to return default value.
      // Otherwise extract the value from the keys which are sent.
      keyArr = keyArr.length > 3 ? _toConsumableArray(keyArr) : [].concat(_toConsumableArray(keyArr), ["DEFAULT"]);
    }
    var value = keyArr.reduce(function (acc, val) {
      if (!acc[val]) throw new ReferenceError("Undefined property: ".concat(val));
      return acc[val];
    }, _this.phrases);
    return value;
  });
  this.locale = locale;
  this.phrases = _defineProperty({}, locale, {});
});

var HaptikPhrases = new Phrases();
HaptikPhrases.setPhrase("USERNAME", "USERNAME").setPhrase("PASSWORD", "PASSWORD").setPhrase("EMAIL", "EMAIL").setPhrase("SIGN_IN", "SIGN IN").setPhrase("SIGN_UP", "SIGN UP").setPhrase("LOG_IN", "LOG IN").setPhrase("LOG_OUT", "LOG OUT").setPhrase("SAVE", "SAVE").setPhrase("DOWNLOAD", "DOWNLOAD");

export default HaptikPhrases;
